<template>
    <div>
        <div class="box-border d-flex flex-wrap align-items-center col-12 col-xl-10" v-for="adm of administrators" :key="adm.name">
            <div class="col-3">
                <NameInitials :name="adm.name" />
                <h5 class="c-ndarkfour mb-0 break">{{adm.name || '-'}}</h5>
                <caption class="c-nmidone">{{adm.associateType || '-'}}</caption>
            </div>
            <div class="col-2 px-0">
                <caption class="c-nmidone">telefone</caption>
                <h5 v-if="adm.phoneNumber" class="c-ndarkfour mb-0 break">{{adm.phoneNumber | formatPhone}}</h5>
                <h5 v-else class="c-ndarkfour mb-0 break">-</h5>
            </div>
            <div class="col-3">
                <caption class="c-nmidone">e-mail</caption>
                <a class="px-0 c-ndarkfour py-0" :href="adm.email ? `mailto:${adm.email}` : ''">
                    <h5 class=" mb-0 break">{{adm.email || '-'}}</h5>
                </a>
            </div>        
        </div>
    </div>
</template>

<script>

import NameInitials from '@/components/icons/NameInitials'

export default {
    props:{
        administrators:{
            required:true,
        }
    },
    components:{
        NameInitials
    },
}
</script>

<style lang="scss" scoped>
</style>